import { DateTime } from 'luxon';

/**
 * How long ago a notification arrived: "just now", "5 min ago", "3 hours ago",
 * "2 days ago", then the date once "ago" stops being the useful part.
 */
export const formatNotificationAge = (iso: string) => {
  const created = DateTime.fromISO(iso);
  if (!created.isValid) return '';
  const diff = DateTime.now().diff(created);

  const minutes = Math.floor(diff.as('minutes'));
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(diff.as('hours'));
  if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;

  const days = Math.floor(diff.as('days'));
  if (days < 7) return `${days} ${days === 1 ? 'day' : 'days'} ago`;

  return created.hasSame(DateTime.now(), 'year')
    ? created.toFormat('MMM d')
    : created.toFormat('MMM d, yyyy');
};

/** The badge's text: past two digits it stops being a number worth reading. */
export const formatUnreadBadge = (count: number) =>
  count > 99 ? '99+' : String(count);
